// Delegated listener — works after cart AJAX re-renders
document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('cart__tc-checkbox')) return;
  var btn = document.getElementById(e.target.dataset.target);
  if (btn) btn.disabled = !e.target.checked;
});
